<template>
  <div class="page-wrap">
    <div class="goods-box" v-if="topicType=='ongoing'">
      <img src="/images/iqiyi/other/top.jpg" alt="">
      <img v-for="(item,index) in goodsArr" :key="index" :src="`/images/iqiyi/goods/${item.goodsId}.jpg`" @click="gotoDetails(item)" alt="">
      <img src="/images/iqiyi/other/footer.jpg" alt="">
      <img src="/images/iqiyi/other/footer-1.jpg" alt="">
    </div>
    <div class="empty-box" v-else-if="topicType=='notline'||topicType=='notstart'||topicType=='end'" :data-type="topicType">
      <div class="bg-box"></div>
      <div class="title-box">{{jsonData[topicType].title}}</div>
      <div class="text-box">{{jsonData[topicType].text}}</div>
      <!-- <div class="btn-box" @click="gotoHome">返回首页</div> -->
    </div>
  </div>
</template>

<script>
import { apiGetTopicGoods, apiGetTopicInfo } from "@/api/iqiyiPurchase";
const wx = require("weixin-js-sdk");
export default {
  name: "iqiyiPurchaseList",
  data() {
    return { 
      goodsArr: [
        { goodsId: "395", name: "vivo S9"},
        { goodsId: "396", name: "vivo X60 Pro+" },
        { goodsId: "397", name: "vivo X60 Pro" },
        { goodsId: "398", name: "vivo X60" },
        { goodsId: "399", name: "vivo S7" },
        { goodsId: "400", name: "vivo WATCH" },
      ],
      topicInfo: {},
      topicType: "",
      jsonData: {
        notline: {
          title: "当前活动未上线",
          text: "您来的太早啦，活动还没开始哦",
        },
        notstart: {
          title: "当前活动未开始",
          text: "您来的太早啦，活动还没开始哦",
        },
        end: {
          title: "当前活动已结束",
          text: "您来的太迟啦，活动已经结束了哦",
        },
      },
    };
  },
  created() {
    this.getTopicInfo();
  },
  mounted() {},
  methods: {
    //获取专题信息
    getTopicInfo() {
      apiGetTopicInfo({ id: this.$route.query.topicId })
        .then((res) => {
          if (res.success) {
            this.topicInfo = res.data;
            if(!this.topicInfo){
              this.$toast(res.msg);
              return;
            }
            if(this.topicInfo.type != 4){
              this.$toast('暂无承载数据！');
              return;
            }
            if (this.topicInfo.status == 2) {
              //活动未上线
              this.topicType = "notline";
            } else {
              let startTimeStr = this.topicInfo.startTime.replace(/-/g, "/");
              let startTimeDate = new Date(startTimeStr).getTime();
              let endTimeStr = this.topicInfo.endTime.replace(/-/g, "/");
              let endTimeDate = new Date(endTimeStr).getTime();
              let currentTimeDate = new Date().getTime();
              if (currentTimeDate > endTimeDate) {
                //活动已结束
                this.topicType = "end";
              }
              if (currentTimeDate < startTimeDate) {
                //活动未开始
                this.topicType = "notstart";
              }
            }
            if (!this.topicType.length) {//活动进行中
              this.topicType = "ongoing";
              // this.getTopicGoods();
            }
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    //获取专题商品
    getTopicGoods() {
      let jsonParam = {
        page: 1,
        pageSize: 100,
        specialId: this.$route.query.topicId,
      };
      apiGetTopicGoods(jsonParam)
        .then((res) => {
          if (res.success) {
            this.goodsArr = res.data.records;
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    //跳转到专题详情
    gotoDetails(row) {
      let topicId = this.$route.query.topicId;
      wx.miniProgram.navigateTo({
        url: `/pages/detailNew/main?id=${row.goodsId}&topicId=${topicId}`,
      });
    },
    //跳转到首页
    gotoHome() {
      wx.miniProgram.switchTab({
        url: "/pages/home/main",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrap {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  .goods-box {
    img {
      width: 100%;
      height: auto;
    }
  }
  .empty-box {
    padding-top: 76px;
    .bg-box {
      width: 153px;
      height: 153px;
      margin: 0 auto;
    }
    .title-box {
      font-size: 20px;
      font-weight: 550;
      text-align: center;
      color: #333333;
      line-height: 28px;
      padding: 12px 0 6px;
    }
    .text-box {
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      text-align: center;
    }
    .btn-box {
      position: absolute;
      left: 50%;
      bottom: 90px;
      margin-left: -100px;
      width: 200px;
      height: 38px;
      font-weight: 550;
      color: #ffffff;
      line-height: 38px;
      text-align: center;
      background: #ff614c;
      border-radius: 19px;
    }
    &[data-type="notline"] {
      .bg-box {
        background: url("/images/iqiyi/not-line-bg.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }
    &[data-type="notstart"] {
      .bg-box {
        background: url("/images/iqiyi/not-start-bg.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
    }
    &[data-type="end"] {
      .bg-box {
        background: url("/images/iqiyi/not-start-bg.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
    }
  }
}
</style>